<div [class.pr-small-x]="includePaddings" [class.pr-small-t]="includePaddings">
  <button
    [attr.id]="'service-item-' + uuid"
    [attr.aria-controls]="'service-item-content-' + uuid"
    [attr.aria-expanded]="expandOpen"
    class="fill flex no-outline"
    (click)="expandOpen = !expandOpen"
    [disabled]="disabled"
  >
    <div class="btn-content fill flex flex--space-between">
      <span class="flex flex--top ms-xsmall-r fill">
        <fcom-icon [name]="getIconForService()" class="icon-medium ms-xsmall-r nordic-blue-900-text"></fcom-icon>
        <div class="flex-1">
          <span class="medium-type font-body-1 flex align-left flex--wrap">
            <span class="flex-1">{{ buttonTranslationKey | finLocalization }}</span>
            <span class="flex--nogrow">{{ additionalTitle }}</span>
          </span>
          <fin-included-product-item-summary
            class="fill align-left block"
            *ngIf="!expandOpen"
            [passengers]="passengers"
            [bound]="bound"
            [service]="service"
          ></fin-included-product-item-summary>
        </div>
      </span>

      <fcom-icon
        name="chevron-down"
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text"
        [class.rotate-active]="expandOpen"
      ></fcom-icon>
    </div>
  </button>
</div>

<fcom-expand
  class="block"
  [open]="expandOpen"
  [ariaId]="'service-item-content-' + uuid"
  [ariaLabelledBy]="'service-item-' + uuid"
>
  <div
    class="flex flex--column"
    [ngClass]="{ 'ms-xsmall-t': !includePaddings, 'mr-small-t pr-small-x': includePaddings }"
  >
    <ng-content></ng-content>
  </div>
</fcom-expand>
